import { getStoreId } from "$/hooks/use-store-information"
import storageLocationQueries from "$/lib/queries/storage-location-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/settings/storage-locations")(
  {
    loader: async ({ context: { queryClient } }) => {
      const storeId = await getStoreId()
      if (storeId) {
        queryClient.prefetchQuery(storageLocationQueries.list(storeId))
      }
      return { crumbs: "alfred.settings.nav.storageLocations.label" }
    },
  },
)
